<template>
    <svg :width="width" :height="height" :viewBox="`0 0 ${width} ${height}`" fill="none" xmlns="http://www.w3.org/2000/svg" :class="classes">
        <path d="M14.1429 8V21.3333H3.85714V8H14.1429ZM12.2143 0H5.78571L4.5 1.33333H0V4H18V1.33333H13.5L12.2143 0ZM16.7143 5.33333H1.28571V21.3333C1.28571 22.8 2.44286 24 3.85714 24H14.1429C15.5571 24 16.7143 22.8 16.7143 21.3333V5.33333Z" fill="#32DAC3"/>
    </svg>
</template>

<script>
export default {
    name: "TrashIcon",

    props: {
        width: {
            type: Number,
            default: 18
        },

        height: {
            type: Number,
            default: 24
        },

        classes: {
            type: String
        }
    }
}
</script>